/* SLOVENŠTINA PRO TRYCHTÝŘE (pages/TrychtyrePage.js, lib/funnelPreview.js) —
 * doplněk sdíleného slovníku UI, klíčem je ČESKÝ TEXT.
 *
 * Vzniklo 24. 10. 2026 (podnět beplan.sk: „lieviky sú zle preložené“):
 * stránka Trychtýře byla u slovenského poradce celá česky — i proužek
 * náhledu nad veřejnou stránkou. Hotové popisky ke sdílení (ty jdou klientům)
 * nejsou tady, ale přímo v TrychtyrePage (podle země poradce).
 * Vlastní soubor, protože prekladyUI.data.js souběžně mění jiné týmy; řádky
 * z ostatních slovníků mají přednost (rozbalují se až za tímto).
 *
 * Chybějící jazyk = čeština (dnešní stav). Teď jen `sk`; en/uk/vi doplnit.
 * ⚠️ ŽÁDNÉ ASCII " UVNITŘ TEXTU (rozbíjí JS string, viz CLAUDE.md).
 */
export const PREKLADY_LIEVIKY = {
  // Trychtýře — stránka
  "Akvizice": { sk: "Akvizícia" },
  "Trychtýře": { sk: "Lieviky" },
  "Zatím ti trychtýře přinesly": { sk: "Zatiaľ ti lieviky priniesli" },
  "leadů": { sk: "leadov" },
  "Náhled funguje hned": { sk: "Náhľad funguje hneď" },
  "— prohlédni si kterýkoli modul i bez nastavení. Pro": { sk: "— pozri si ktorýkoľvek modul aj bez nastavenia. Pre" },
  "ostrý odkaz, QR a sdílení": { sk: "ostrý odkaz, QR a zdieľanie" },
  "v Nastavení": { sk: "v Nastaveniach" },
  "Leadů z tohoto trychtýře": { sk: "Leady z tohto lievika" },
  "Náhled": { sk: "Náhľad" },
  "Náhled modulu": { sk: "Náhľad modulu" },
  "Sdílet (QR + popisky)": { sk: "Zdieľať (QR + popisky)" },
  "Sdílet modul": { sk: "Zdieľať modul" },
  "Nejdřív si nastav odkaz vizitky v Nastavení": { sk: "Najprv si nastav odkaz vizitky v Nastaveniach" },
  // Sdílecí okno
  "Sdílet:": { sk: "Zdieľať:" },
  "Na leták, vizitku, prezentaci nebo na schůzku — klient si naskenuje a otevře.": { sk: "Na leták, vizitku, prezentáciu alebo na stretnutie — klient si naskenuje a otvorí." },
  "Stáhnout QR": { sk: "Stiahnuť QR" },
  "Hotové popisky ke zkopírování": { sk: "Hotové popisky na skopírovanie" },
  "Zkop.": { sk: "Skop." },
  "Texty si uprav podle sebe — čísla a sliby si ověř pro svůj region.": { sk: "Texty si uprav podľa seba — čísla a sľuby si over pre svoj región." },
  // Proužek náhledu nad veřejnou stránkou (vidí jen poradce)
  "Náhled.": { sk: "Náhľad." },
  "Takhle stránku uvidí klient. Pro ostrý odkaz si nastav vizitku v Nastavení — pak se leady ukládají do CRM.": { sk: "Takto stránku uvidí klient. Pre ostrý odkaz si nastav vizitku v Nastaveniach — potom sa leady ukladajú do CRM." },
  "Tvoje jméno": { sk: "Tvoje meno" },
  // Chybové hlášky backendu při odeslání leadu (routes/leadgen.py posílá česky)
  "Zadejte celé jméno": { sk: "Zadajte celé meno" },
  "Zadejte telefon nebo email": { sk: "Zadajte telefón alebo e-mail" },
  "Zadejte telefon nebo e-mail": { sk: "Zadajte telefón alebo e-mail" },
  "Zadejte platné telefonní číslo": { sk: "Zadajte platné telefónne číslo" },
  "Poradce nenalezen": { sk: "Poradca sa nenašiel" },
};

export default PREKLADY_LIEVIKY;
